module.exports = __webpack_public_path__ + "static/media/react-step-form.c98a3d4a.png";